import React, { useRef, useCallback, useState, useEffect } from 'react';
import {
    ReactFlow,
    ReactFlowProvider,
    addEdge, applyEdgeChanges, applyNodeChanges,
    useNodesState,
    useEdgesState,
    Controls,
    useReactFlow,
    Background,
} from 'reactflow';
import '../index.css';
import '@xyflow/react/dist/style.css';
import Sidebar from './Sidebar';
import { DnDProvider, useDnD } from './DnDContext';
import 'reactflow/dist/style.css';
import './text-updater-node.css';
import Settingbar from './Settingbar';
import { Button } from 'react-bootstrap';
import Header from './Header';
import LoopEvent from './Events/LoopEvent';
import StartEvent from './Events/StartEvent';
import ActionEvent from './Events/ActionEvent';
import DecisionEvent from './Events/DecisionEvent';
import WaitEvent from './Events/WaitEvent';
import NotificationEvent from './Events/NotificationEvent';
import EndEvent from './Events/EndEvent';
import TaskEvent from './Events/TaskEvent';
import { useParams } from 'react-router-dom';
import { WORKFLOWS_DETAILS_WORKFLOW_API, WORKFLOWS_GET_SETTING_API } from 'Constant/api';
import { authService } from 'Service/Axios';
import EditableEdge from './Events/EditableEdge';

const edgeTypes = {
    editable: EditableEdge,
};

const nodeTypes = { start: StartEvent, action: ActionEvent, decision: DecisionEvent, loop: LoopEvent, wait: WaitEvent, notification: NotificationEvent, end: EndEvent, task: TaskEvent };

let id = 1;
const getId = () => `${id++}`;

const initialNodes = [
    {
        id: getId(),
        type: 'start',
        data: {
            label: 'Main Label',
            description: 'Secondary Label',
            type: 'start',
            role: '',
            date: new Date().toISOString().split('T')[0],
            loopCount: '',
            maxDuration: '',
            templateID: 'SEND_MAIL',
            trigger: 'before',
            triggerType: 'Event Based',
            triggerDetails: 'Form Submission',
            endType: 'Success',
            actionType: '',
            actionConfig: '',
            notificationType: 'Email',
            notificationDetails: 'Role',
            amount: '',
            unit: '',
            fieldName: '',
            templateName: '',
            email: [""],
            decisionButton: [""],
            status: '',
            stages: '',
            generatePDF: '',
            targetFields: '',
            paragraph: '',
            mainConditions: []
        },
        position: { x: 250, y: 10 },
        style: { padding: '0px' },
    },
];

const DnDFlow = () => {
    const { workflowId } = useParams();
    const reactFlowWrapper = useRef(null);
    const [nodes, setNodes] = useNodesState(initialNodes);
    const onNodesChange = useCallback((changes) => setNodes((nds) => applyNodeChanges(changes, nds)), [setNodes]);
    const [edges, setEdges] = useEdgesState([]);

    const updateEdgeLabel = (id, newLabel) => {
        setEdges((eds) =>
            eds.map((edge) =>
                edge.id === id ? { ...edge, data: { ...edge.data, label: newLabel, onChange: updateEdgeLabel } } : edge
            )
        );
    };
    const onEdgesChange = useCallback((changes) => setEdges((eds) => applyEdgeChanges(changes, eds)), [setEdges]);
    const { screenToFlowPosition } = useReactFlow();
    const [type, setType] = useDnD();
    const [selectedNodes, setSelectedNodes] = useState([]);
    const [val, setVal] = useState({
        label: 'Main Label',
        description: 'Secondary Label',
        type: 'start',
        role: 'Faculty',
        rule: 'Auto Completion',
        date: new Date().toISOString().split('T')[0], // Default to today's date
        nextEvent: 'Label',
        duration: '1 Day',
        position: 'X',
        templateID: 'SEND_MAIL',
        trigger: 'before',
        triggerID: 'Faculty',
        triggerType: 'Event Based',
        triggerDetails: 'Form Submission',
        endType: 'Success',
        actionType: '',
        actionConfig: '',
        notificationType: 'Email',
        notificationDetails: 'Role',
        conditions: '',
        loopScope: '',
        amount: '',
        unit: '',
        templateName: '',
        email: [""],
        templateDescription: '',
        decisionButton: [""],
        status: '',
        stages: '',
        generatePDF: '',
        targetFields: '',
        paragraph: '',
        mainConditions: []
    })
    const [workflowDetail, setworkflowDetail] = useState()
    const onConnect = useCallback((connection) => {
        setEdges((eds) =>
            addEdge(
                {
                    ...connection,
                    type: 'editable',
                    data: { label: '', onChange: updateEdgeLabel },
                },
                eds
            )
        );
    }, []);

    const onDragOver = useCallback((event) => {
        event.preventDefault();
        event.dataTransfer.dropEffect = 'move';
    }, []);

    const onDrop = useCallback(
        (event) => {
            event.preventDefault();

            // check if the dropped element is valid
            if (!type) {
                return;
            }

            const position = screenToFlowPosition({
                x: event.clientX,
                y: event.clientY,
            });
            const newNode = {
                id: getId(),
                type: type,
                position,
                data: {
                    label: 'Main Label',
                    type: type,
                    role: 'Faculty',
                    field: [Math.random().toString(36).substring(2, 15)], // Generate a random ID for the field
                    rule: 'Auto Completion',
                    date: new Date().toISOString().split('T')[0], // Default to today's date
                    nextEvent: 'Label',
                    duration: '1 Day',
                    position: 'X',
                    templateID: 'SEND_MAIL',
                    trigger: 'before',
                    triggerID: 'Faculty',
                    triggerType: 'Event Based',
                    triggerDetails: 'Form Submission',
                    description: 'Secondary Label',
                    endType: 'Success',
                    actionType: '',
                    actionConfig: '',
                    notificationType: 'Email',
                    notificationDetails: 'Role',
                    conditions: '',
                    loopScope: '',
                    amount: '',
                    unit: '',
                    templateName: '',
                    email: [""],
                    templateDescription: '',
                    decisionButton: [""],
                    status: '',
                    stages: '',
                    generatePDF: '',
                    targetFields: '',
                    paragraph: '',
                    mainConditions: []
                },
                style: { padding: '0px' },
            };

            setNodes((nds) => nds.concat(newNode));
        },
        [screenToFlowPosition, type],
    );

    const onDragStart = (event, nodeType) => {
        setType(nodeType);
        event.dataTransfer.setData('text/plain', nodeType);
        event.dataTransfer.effectAllowed = 'move';
    };

    const onNodeClick = (event, node) => {
        // getSettings(node.type, node.id)
        setSelectedNodes((prev) => {
            if (event.shiftKey) {
                // Multi-select
                return prev.find((n) => n.id === node.id)
                    ? prev.filter((n) => n.id !== node.id)
                    : [...prev, node];
            } else {
                return [node];
            }
        });

        setVal({
            label: node.data.label,
            type: node.data.type,
            role: node.data.role,
            field: node.data.field, // Generate a random ID for the field
            rule: node.data.rule,
            date: node.data.date, // Default to today's date
            nextEvent: node.data.nextEvent,
            duration: node.data.duration,
            position: node.data.position,
            templateID: node.data.templateID,
            trigger: node.data.trigger,
            triggerID: node.data.triggerID,
            triggerType: node.data.triggerType,
            triggerDetails: node.data.triggerDetails,
            description: node.data.description,
            endType: node.data.endType,
            actionType: node.data.actionType,
            actionConfig: node.data.actionConfig,
            notificationType: node.data.notificationType,
            notificationDetails: node.data.notificationDetails,
            conditions: node.data.conditions,
            loopScope: node.data.loopScope,
            amount: node.data.amount,
            unit: node.data.unit,
            templateName: node.data.templateName,
            email: node.data.email,
            templateDescription: node.data.templateDescription,
            decisionButton: node.data.decisionButton,
            status: node.data.status,
            stages: node.data.stages,
            generatePDF: node.data.generatePDF,
            targetFields: node.data.targetFields,
            paragraph: node.data.paragraph,
            mainConditions: node.data.mainConditions
        });
    };

    const getSettings = async (dataType, id) => {
        const data = {
            gid: id,
            type: dataType
        };
        const response = await authService(
            WORKFLOWS_GET_SETTING_API,
            "POST",
            data
        );
        if (response) setVal(response);
    };

    const handleDelete = () => {
        const selectedIds = selectedNodes.map((n) => n.id);
        setNodes((nds) => nds.filter((node) => !selectedIds.includes(node.id)));
        setEdges((eds) => eds.filter((edge) => !selectedIds.includes(edge.source) && !selectedIds.includes(edge.target)));
        setSelectedNodes([]);
    };

    useEffect(() => {
        getWorkflowDetail()
    }, [])

    const getWorkflowDetail = async () => {
        const payload = {
            gid: workflowId
        };
        const response = await authService(WORKFLOWS_DETAILS_WORKFLOW_API, "POST", payload);
        if (response) {
            setworkflowDetail(response);
            if (response?.nodes && response?.nodes.length > 0) {
                setNodes(response.nodes);
            }
            if (response?.edges && response?.edges.length > 0) {
                setEdges(response.edges);
            }
        }
    };

    return (
        <>
            <Header workflowDetail={workflowDetail} nodes={nodes} edges={edges} />
            <div className="dndflow">
                <Sidebar />
                <div className="reactflow-wrapper" ref={reactFlowWrapper}>
                    <ReactFlow
                        nodes={nodes}
                        edges={edges}
                        onNodesChange={onNodesChange}
                        onEdgesChange={onEdgesChange}
                        onConnect={onConnect}
                        onDrop={onDrop}
                        onDragStart={onDragStart}
                        onDragOver={onDragOver}
                        style={{ backgroundColor: '#F7F9FB' }}
                        onNodeClick={onNodeClick}
                        nodeTypes={nodeTypes}
                        edgeTypes={edgeTypes}
                    >
                        <Controls />
                        <Background />
                    </ReactFlow>
                </div>
                {selectedNodes.length > 0 && <Settingbar val={val} setVal={setVal} setNodes={setNodes} handleDelete={handleDelete} selectedNodes={selectedNodes} setSelectedNodes={setSelectedNodes} workflowDetail={workflowDetail} nodes={nodes} />}
            </div>
        </>
    );
};

export default () => (
    <ReactFlowProvider>
        <DnDProvider>
            <DnDFlow />
        </DnDProvider>
    </ReactFlowProvider>
);
